import http from '../core/http-common'
import { ITransactionResponse, IRemoteOfficeType } from '../types/MainType'
import { IRemoteReservationResponse } from '../types/RemoteReservationRequest'

class RequestHomeOfficeService {
  getFilteredList(request: any) {
    return http.post<IRemoteReservationResponse[]>('/HomeOfficeReservationRequest/GetFilteredList', request)
  }

  changeRequestStatus(request: any) {
    return http.post<ITransactionResponse>('/HomeOfficeReservationRequest/ChangeRequestStatus', request)
  }

  getPendingApprovalCount(startDate?: Date, endDate?: Date) {
    const params: any = {}
    if (startDate) params.startDate = startDate.toISOString()
    if (endDate) params.endDate = endDate.toISOString()
    return http.get<number>('/HomeOfficeReservationRequest/GetPendingApprovalCount', { params })
  }
}

export default new RequestHomeOfficeService()
